import { usePageTitle } from "@/hooks/usePageTitle";

export function FaqPage() {
  usePageTitle("DUK");

  const faqs = [
    {
      question: "Kas yra Boardo?",
      answer:
        "Boardo – tai stalo žaidimų turgavietė, kurioje galite pirkti ir parduoti stalo žaidimus. Mūsų tikslas – padėti žaidėjų bendruomenei rasti naujus žaidimus ir suteikti naują gyvenimą nebežaidžiamiems žaidimams.",
    },
    {
      question: "Kaip parduoti žaidimą?",
      answer:
        'Prisijunkite prie savo paskyros, spauskite „Parduoti žaidimą" ir užpildykite skelbimo formą. Galite nufotografuoti žaidimą – sistema automatiškai atpažins žaidimą iš nuotraukos.',
    },
    {
      question: "Kaip nupirkti žaidimą?",
      answer:
        "Naršykite skelbimus arba ieškokite konkretaus žaidimo. Radę norimą skelbimą, susisiekite su pardavėju per žinučių sistemą ir susitarkite dėl pirkimo sąlygų.",
    },
    {
      question: "Ar Boardo ima mokestį už skelbimus?",
      answer:
        "Šiuo metu skelbimų talpinimas Boardo platformoje yra nemokamas.",
    },
    {
      question: "Kaip veikia žaidimo būklės įvertinimas?",
      answer:
        'Kiekvienas skelbimas turi būklės žymą: „Naujas", „Labai gera", „Gera", „Patenkinama" arba „Prasta". Pardavėjas pats nustato žaidimo būklę pagal tai, kaip žaidimas atrodo ir ar visi komponentai yra vietoje.',
    },
    {
      question: "Kaip susisiekti su pardavėju?",
      answer:
        "Kiekviename skelbime rasite mygtuką susisiekti su pardavėju. Žinutės siunčiamos per Boardo platformą – jūsų kontaktiniai duomenys lieka privatūs.",
    },
    {
      question: "Ką daryti, jei kilo problema su pirkimu?",
      answer:
        "Jei susidūrėte su problema, pirmiausia pabandykite ją išspręsti tiesiogiai su pardavėju per žinučių sistemą. Jei nepavyksta – susisiekite su mumis el. paštu info@boardo.lt.",
    },
  ];

  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
      <h1 className="mb-8 text-3xl font-bold text-gray-900">
        Dažnai užduodami klausimai
      </h1>

      <div className="space-y-6">
        {faqs.map((faq, index) => (
          <div key={index} className="rounded-lg border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900">
              {faq.question}
            </h2>
            <p className="mt-2 text-gray-600">{faq.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
